var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page-title',{attrs:{"color":_vm.color},scopedSlots:_vm._u([{key:"pageTitleLeft",fn:function(){return [_c('h1',[_vm._t("default")],2)]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }